<template>
  <div>
    <h1>{{ $t("page.404") }}</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {
      roomId: "",
    };
  },
  methods: {
    onSubmit() {
      this.$router.push(`/${this.roomId}`);
    },
    changeLocale(lang) {
      if (this.$i18n.locale === lang) return;
      this.$i18n.locale = lang;
    },
  },
};
</script>
